import { Typography } from 'antd';
import React from 'react'

const CopyInfoComponent = (props) => {
    const { data, textStyle } = props;
    const { Text } = Typography;
    return (
        <div>
            <ul className='mb-0'>
                <li>
                    <Text style={textStyle}>{`Rx BIN: ${data?.insuranceCard?.rxBin || 'N/A'}`}</Text>
                </li>
                <li>
                    <Text style={textStyle}>{`Rx PCN: ${data?.insuranceCard?.rxPcn || 'N/A'}`}</Text>
                </li>
                <li>
                    <Text style={textStyle}>{`Rx Group: ${data?.insuranceCard?.rxGroup || 'N/A'}`}</Text>
                </li>
                <li>
                    <Text style={textStyle}>{`Rx Member: ${data?.copayCardInfo?.memberId || 'N/A'}`}</Text>
                </li>
            </ul>
        </div>
    )
}

export default CopyInfoComponent